<template>
    <div class="approval-record-dialog">
        <el-dialog title="操作记录" v-dialogDrag :visible.sync="visible" :before-close="onClose">
            <el-table :data="tableData" :height="380" border stripe v-loading="loading" style="width: 100%">
                <el-table-column show-overflow-tooltip prop="mipId" label="流程ID"></el-table-column>
                <el-table-column show-overflow-tooltip prop="_auditType" label="审批类型"></el-table-column>
                <el-table-column show-overflow-tooltip prop="_auditStatus" label="审批状态"></el-table-column>
                <el-table-column show-overflow-tooltip prop="operatorName" label="操作人"></el-table-column>
                <el-table-column show-overflow-tooltip prop="_operate" label="操作"></el-table-column>
                <el-table-column show-overflow-tooltip prop="operateTime" label="操作时间"></el-table-column>
            </el-table>
            <el-row type="flex" class="row-page" justify="space-between">
                <el-col :offset="12" :span="12">
                    <m-page
                        ref="page"
                        :current-page="currentPage"
                        :pageData="pageConfig"
                        :total="pageTotal"
                        @on-page-change="pageChange"
                        @on-size-change="sizeChange"></m-page>
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>
<script>
import mPage from '@/components/supplierPanel/mPage'
import { dictWithUrl } from '@/components/lots/api'
import {
    supplierWarehouseDelegateOperateRecord,
} from '../../../api/warehouseResourceManagement/warehouseDelegationLetter.js'

export default {
    components: { mPage },
    data() {
        return {
            warehouseDelegateNo: '',
            pageTotal: 0,
            pageNo: 1,
            pageSize: 10,
            currentPage: 1,
            pageConfig: {
                layout: 'total, sizes, prev, pager, next',
                pageSize: 10,
            },
            tableData: [],
            dictData: {}, // 数字字典
            loading: false,
            visible: false,
        }
    },
    methods: {
        show(warehouseDelegateNo) {
            this.visible = true
            this.tableData =[];
            this.currentPage = 1
            this.pageNo = 1
            this.pageTotal = 0
            this.warehouseDelegateNo = warehouseDelegateNo
            this.getData()
        },
        onClose() {
            this.visible = false
        },
        pageChange(pageNo) {
            this.pageNo = pageNo
            this.loadData()
        },
        sizeChange(size) {
            this.pageSize = size
            this.loadData()
        },
        getData() {
            dictWithUrl('WAREHOUSE_OPERATE_TYPE,WAREHOUSE_DELEGATE_AUDIT_STATUS,WAREHOUSE_DELEGATE_AUDIT_TYPE').then(res => {
                this.dictData = res.data
                this.loadData()
            })
        },
        async loadData() {
            this.loading = true;
                const params = {
                    warehouseDelegateNo:this.warehouseDelegateNo,
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                    orderBy: 'operate_time',
                    orderByType: 'desc',
                };
            const res = await supplierWarehouseDelegateOperateRecord(params);
            this.loading = false;
            if (res && res.code === '0') {
                const {list,totalPage,totalCount}=res.data;
                this.pageTotal =totalCount;
                let dataList=[];
                if(Array.isArray(list)&&list.length){
                    dataList=this.conversionData(list);
                }
                this.tableData =dataList;
            }
        },
        conversionData(list) {
            for (const item of list) {
                item._operate = this.dictData.WAREHOUSE_OPERATE_TYPE[item.operate]
                item._auditStatus = this.dictData.WAREHOUSE_DELEGATE_AUDIT_STATUS[item.auditStatus] // 审批状态 auditStatus  数据字典 WAREHOUSE_DELEGATE_AUDIT_STATUS
                item._auditType = this.dictData.WAREHOUSE_DELEGATE_AUDIT_TYPE[item.auditType] // // 审批类型 auditType  数据字典 WAREHOUSE_DELEGATE_AUDIT_TYPE
            }
            return list
        },
    },
}
</script>
<style scoped lang="less">
/deep/.el-dialog{
    width: 1100px !important;
}
.approval-record-dialog {
    .row-page {
        margin-top: 20px;
    }
    .blue-color {
        cursor: pointer;
        color: #00bcbf;
    }
    .gray-color {
        color: #888888;
    }
}
</style>
